import { call, put, select, takeLatest, all } from 'redux-saga/effects';
import * as types from '../constants/actionTypes';
import * as healthPlan from '../api/healthPlanApi';
import { log, logAPI } from "../api/andyliticsApi";

const technicalHelpDeskNumber = window.serverData ? window.serverData.data.technicalHelpDeskNumber : "855.691.0180";
const technicalHelpDeskHours = window.serverData ? window.serverData.data.technicalHelpDeskHours : "";
const phoneNumber = "<a href='tel:800.784.5473'>800.784.5473</a>";
const phoneNumber2 = `<a href='tel:${technicalHelpDeskNumber}'>${technicalHelpDeskNumber}</a>`;

export default function* healthPlanSaga() {
    yield takeLatest([types.USER_AUTHENTICATE_SUCCESS], handleHealthPlanAction);
    yield takeLatest([types.LOAD_HEALTHPLANDASHBOARD_START], handleHealthPlanAction);
    yield takeLatest([types.LOAD_HEALTHPLAN_DATA_START], loadHealthPlanTileAction);
    yield takeLatest([types.LINK_HEALTHPLAN_ACCOUNT], handleLinkHealthPlanAccount);
    yield takeLatest([types.LINK_HEALTHPLAN_ACCOUNT_SUCCESS], handleLinkHealthPlanAccount);
    yield takeLatest([types.UNLINK_HEALTHPLAN_ACCOUNT], handleUnlinkHealthPlanAccount);
    yield takeLatest([types.UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS], handleUnlinkHealthPlanAccount);
    yield takeLatest([types.LINK_AUTO_HP_ACCOUNT_START], linkAAAcountAction);
    yield takeLatest([types.LINK_AA_ACCOUNT_START], linkAAAcountAction);
    yield takeLatest([types.LINK_AA_ACCOUNT_SUCCESS], linkAAAcountAction);
    yield takeLatest([types.LINK_AA_ACCOUNT_FAILURE], linkAAAcountAction);
    yield takeLatest([types.LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS], linkAAAcountAction);
    yield takeLatest([types.UNLINK_AA_ACCOUNT_START], unLinkAAAcountAction);
    yield takeLatest([types.UNLINK_AA_ACCOUNT_SUCCESS], unLinkAAAcountAction);
    yield takeLatest([types.UNLINK_AA_ACCOUNT_FAILURE], unLinkAAAcountAction);
    yield takeLatest([types.UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS], unLinkAAAcountAction);
    yield takeLatest([types.LINK_FIRST_CARE_ACCOUNT], linkFirstCareAccountAction);
    yield takeLatest([types.UNLINK_FIRST_CARE_ACCOUNT], unlinkFirstCareAccountAction);
    yield takeLatest([types.LINK_DART_ACCOUNT], linkDartAccountAction);
    yield takeLatest([types.UNLINK_DART_ACCOUNT], unlinkDartAccountAction);
    yield takeLatest([types.LINK_WACO_ACCOUNT], linkWACOAccountAction);
    yield takeLatest([types.UNLINK_WACO_ACCOUNT], unlinkWacoAccountAction);
}

function* handleHealthPlanAction(data) {
    const start = new Date();
    const stateData = yield select((state) => state.common);
    const enableNewHealthPlan = window && window.serverData.data.enableNewHealthPlan;
    //If new health plan is enabled then not required to call this API.
    if (typeof enableNewHealthPlan !== 'undefined' && !enableNewHealthPlan) {
        if (stateData && stateData.swhpDown === false) {
            try {
                const userDetails = yield select((state) => state.sso.userDetails);
                const hasHealthPlan = userDetails.Logins.indexOf('HealthPlan') > -1;
                if (userDetails && hasHealthPlan) {
                    const response = yield call(healthPlan.getHealthPlanData, userDetails.access_token);
                    yield put({ type: types.LOAD_HEALTHPLANDASHBOARD_SUCCESS, healthPlanDashboardData: response, isWaiting: false });
                    logAPI("MBHWeb.HealthPlan.Dashboard.GetPlanData", start, null);
                }
            }
            catch (response) {
                console.error(response);
                if (response && response.status && response.status === 401) {
                    yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                    logAPI("MMBHWeb.HealthPlan.Dashboard.GetPlanData.Failure.Login", start, null, response);
                }
                else {
                    yield put({ type: types.AJAX_CALL_ERROR, healthPlanError: response });
                    logAPI("MBHWeb.HealthPlan.Dashboard.GetPlanData.Failure", start, null, response);
                }
            }
        }
        else {
            console.log("healthPlanSaga: swhpDown");
        }
    }
}

function* loadHealthPlanTileAction() {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const sessionData = yield select((state) => state.session);
    const start = new Date();

    let healthPlanName = "";
    if (sessionData) {
        if (sessionData.hasSWHP)
            healthPlanName = 'SWHP';
        else if (sessionData.hasFirstCare)
            healthPlanName = 'FC';
        else if (sessionData.hasAAL)
            healthPlanName = 'AA';
    }
    try {
        if (domainData) {
            let isHealthPlanDown = false;
            if (domainData.hi || domainData.hri) {
                if (stateData && stateData.swhpDown === true) {
                    isHealthPlanDown = true;
                    console.log("healthPlanSaga: swhpDown");
                }
            }
            else if (domainData.aal) {
                if (stateData && stateData.aalDown === true) {
                    isHealthPlanDown = true;
                    console.log("healthPlanSaga: aalDown");
                }
            }
            if (domainData.t && !isHealthPlanDown && domainData.un) {
                const response = yield call(healthPlan.getHealthPlanTileData, domainData.t, domainData.un, healthPlanName);
                yield put({ type: types.LOAD_HEALTHPLAN_DATA_SUCCESS, HealthPlanTileData: response });
                logAPI(`MBHWeb.Saga.${healthPlanName}.DataTile.Success`, start, null);
            }
        }

    }
    catch (response) {
        console.error(response);
        if (response && response.status && response.status === 401) {
            yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
            logAPI(`MBHWeb.Saga.${healthPlanName}.DataTile.Failure.Login`, start, null, response);
        }
        else {
            yield put({ type: types.LOAD_HEALTHPLAN_DATA_FAILURE, healthPlanDataError: response });
            logAPI(`MBHWeb.Saga.${healthPlanName}.DataTile.Failure`, start, null, response);
        }
    }
}

function* handleLinkHealthPlanAccount(data) {
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData && stateData.swhpDown === false) {
        try {
            const domainData = yield select((state) => state.domain);
            switch (data.type) {
                case types.LINK_HEALTHPLAN_ACCOUNT:
                    let response = yield call(healthPlan.linkHPAccount, domainData.t, data.memberId, domainData.un, data.dob, data.ssn);
                    if (response && response.MembershipProfile) {
                        logAPI("MBHWeb.Saga.SWHP.Link.Success", start, null, { payload: data, response });
                        yield put({ type: types.LINK_HEALTHPLAN_ACCOUNT_SUCCESS, membershipProfile: response.MembershipProfile, isStandalone: data.isFromMobile ? true : false });
                    }
                    else {
                        logAPI("MBHWeb.Saga.SWHP.Link.Failure", start, null, { payload: data, response });
                        yield put({ type: types.LINK_HEALTHPLAN_ACCOUNT_FAILURE, error: response && typeof response === 'string' ? response : response && response.Errors && response.Errors[0] && response.Errors[0].DisplayMessage ? response.Errors[0].DisplayMessage : "We're unable to link your account."});
                    }
                    break;
                case types.LINK_HEALTHPLAN_ACCOUNT_SUCCESS:
                    yield put({ type: types.REFRESH_TOKEN });
                    yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: data.membershipProfile});
                    if (!data.isStandalone) {
                        window.setTimeout(() => {
                            window.store.dispatch({ type: types.LINK_HEALTHPLAN_CLEAR_MESSAGE });
                        }, 10000);
                    }
                    break;
            }
        }
        catch (exception) {
            console.error(exception);
            logAPI("MBHWeb.Saga.SWHP.Link.Failure", start, null, { payload: data, error: exception });
            yield put({ type: types.LINK_HEALTHPLAN_ACCOUNT_FAILURE, error: exception && exception.message ? exception.message : "Failed to link employee account." });
        }
    }
    else {
        console.log("healthSourceSaga: swhpDown");
    }
}


function* handleUnlinkHealthPlanAccount(data) {
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData && stateData.swhpDown === false) {
        try {
            const domainData = yield select((state) => state.domain);
            const memberId = data.MemberId ? data.MemberId : null;
            switch (data.type) {
                case types.UNLINK_HEALTHPLAN_ACCOUNT:
                    let response = yield call(healthPlan.unLinkHPAccount, domainData.t, memberId, domainData.un);
                    if (response?.MembershipProfile) {
                        logAPI("MBHWeb.Saga.SWHP.UnLink.Success", start, null, { response });
                        yield put({ type: types.UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS, membershipProfile: response.MembershipProfile, isStandalone: data.isFromMobile ? true : false });
                    }
                    else {
                        logAPI("MBHWeb.Saga.SWHP.UnLink.Failure", start, null, { response });
                        yield put({ type: types.UNLINK_HEALTHPLAN_ACCOUNT_FAILURE, error: response && typeof response === 'string' ? response : response && response.Errors && response.Errors[0] && response.Errors[0].DisplayMessage ? response.Errors[0].DisplayMessage : "We're unable to unlink your account." });
                    }
                    break;
                case types.UNLINK_HEALTHPLAN_ACCOUNT_SUCCESS:
                    yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: data.membershipProfile });
                    yield put({ type: types.REFRESH_TOKEN }); // this picks up the refresh token from domain now
                    if (!data.isStandalone) {
                        window.setTimeout(() => {
                            window.store.dispatch({ type: types.UNLINK_HEALTHPLAN_CLEAR_MESSAGE });
                        }, 10000);
                    }

                    break;

            }
        }
        catch (exception) {
            console.error(exception);
            logAPI("MBHWeb.Saga.SWHP.UnLink.Failure", start, null, exception);
            yield put({ type: types.UNLINK_HEALTHPLAN_ACCOUNT_FAILURE, error: exception && exception.message ? exception.message : "Failed to unlink health plan account." });
        }
    }
    else {
        console.log("healthSourceSaga: swhpDown");
    }
}



function* linkAAAcountAction(data) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData && stateData.aalDown === false) {
        try {
            switch (data.type) {
               case types.LINK_AUTO_HP_ACCOUNT_START:
                    if (domainData && domainData.t) {
                        const userRole = data.payload.userRole ? data.payload.userRole : "SWHP";
                        const response = yield call(healthPlan.linkAutoHPAccount, domainData.t, data.payload.providerKey, domainData.un, data.payload.loginProvider, userRole);
                        if (response.status === 200) {
                            yield put({ type: types.REFRESH_TOKEN });
                            yield put({ type: types.LINK_AUTO_HP_ACCOUNT_SUCCESS });
                            logAPI(`MBHWeb.Saga.${userRole}.AutoLink.Success`, start, null, { "LoginProvider": data.payload.loginProvider });
                        }
                        else {
                            yield put({ type: types.LINK_AUTO_HP_ACCOUNT_FAILURE, linkError: response });
                            let errorJson = { "LoginProvider": data.payload.loginProvider, "error": response };
                            logAPI(`MBHWeb.Saga.${userRole}.AutoLink.Failure`, start, null, errorJson);
                        }
                    }
                    break;
                case types.LINK_AA_ACCOUNT_START:
                    if (domainData && domainData.t) {
                        const logPayloadData = { ...data.payload, ssn: "" };
                        try {
                            const response = yield call(healthPlan.linkAAAccount, domainData.t, data.payload.memberId, domainData.un, data.payload.dob, data.payload.ssn);
                            if (response?.MembershipProfile) {
                                yield put({
                                    type: types.LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS, membershipProfile: response.MembershipProfile, isStandalone: data.payload.isStandalone || data.payload.isFromMobile ? true : false,
                                    memberId: response && response.memberNumber ? response.memberNumber : null
                                });
                                logAPI("MBHWeb.Saga.AA.Link.Success", start, null, { payload: logPayloadData, response: response });
                            } else if (response && response.Errors && response.Errors.length > 0) {
                                const error = getLinkAAError(response.Errors[0]);
                                yield put({ type: types.LINK_AA_ACCOUNT_FAILURE, linkError: error });
                                yield put({ type: types.LINK_AA_ACCOUNT_ERROR_COUNT });
                                logAPI("MBHWeb.Saga.AA.Link.Failure", start, null, { payload: logPayloadData, response: response });
                            }
                        }
                        catch (error) {
                            logAPI("MBHWeb.Saga.AA.Link.Failure", start, null, { payload: logPayloadData, error: error });
                        }
                    }
                    break;
                case types.LINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS:
                    try {
                        logAPI("MBHWeb.Saga.AA.Link.Tokenupdate", start, null);
                        yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: data.membershipProfile });
                        yield put({ type: types.REFRESH_TOKEN });
                        yield put({ type: types.LINK_AA_ACCOUNT_SUCCESS, memberId: data.memberId });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.LINK_AA_ACCOUNT_CLEAR_MESSAGE });
                            }, 10000);
                        }
                    } catch (error1) {
                        console.log(error1);
                        logAPI("MBHWeb.Saga.AA.Link.Tokenupdate.Error", start, null, error1);
                    }
                    break;
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.AA.Link.Failure.Login", start, null, response);
            }
            else {
                yield put({ type: types.LINK_AA_ACCOUNT_FAILURE });
                logAPI("MBHWeb.Saga.AA.Link.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("healthPlanSaga: aalDown");
    }
}

function* unLinkAAAcountAction(data) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData && stateData.aalDown === false) {
        try {
            switch (data.type) {
                case types.UNLINK_AA_ACCOUNT_START:
                    if (domainData && domainData.t) {
                        const response = yield call(healthPlan.unLinkAAAccount, domainData.t, data.payload.memberId, domainData.un);
                        if (response?.MembershipProfile) {
                            yield put({ type: types.UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS, membershipProfile: response.MembershipProfile, isFromMobile: data.payload.isFromMobile ? true : false });
                            logAPI("MBHWeb.Saga.AA.UnLink.Success", start, null);
                        }
                        else {
                            if (response && response.Errors && response.Errors.length > 0) {
                                const error = getUnLinkAAError(response.Errors[0]);
                                yield put({ type: types.UNLINK_AA_ACCOUNT_FAILURE, unLinkAAError: error });
                            }
                            logAPI("MBHWeb.Saga.AA.UnLink.Failure", start, null, response);
                        }
                    }
                    break;
                case types.UNLINK_AA_ACCOUNT_UPDATE_TOKEN_SUCCESS:
                    try {
                        logAPI("MBHWeb.Saga.AA.UnLink.Tokenupdate", start, null);
                        yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: data.membershipProfile });
                        yield put({ type: types.REFRESH_TOKEN });
                        yield put({ type: types.UNLINK_AA_ACCOUNT_SUCCESS });
                        if (!data.isFromMobile) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.UNLINK_AA_ACCOUNT_CLEAR_MESSAGE });
                            }, 10000);
                        }
                    } catch (error) {
                        console.log(error);
                        logAPI("MBHWeb.Saga.AA.UnLink.Tokenupdate.Error", start, null, error);
                    }
                    break;
            }
        }
        catch (response) {
            console.error(response);
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.AA.UnLink.Failure.Login", start, null, response);
            }
            else {
                yield put({ type: types.UNLINK_AA_ACCOUNT_FAILURE, unLinkAAError: getUnLinkAAError(null) });
                logAPI("MBHWeb.Saga.AA.UnLink.Failure", start, null, response);
            }
        }
    }
    else {
        console.log("healthPlanSaga: aalDown");
    }
}

function getLinkAAError(error) {
    if (error && error.Code) {
        switch (error.Code) {
            case "data_mismatch":
            case "no_records_match":
                return { __html: `We could not find a matching account. Please verify your information and try again. For assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.` };
            case "multiple_records_match":
                return { __html: `We could not find that account. For assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.` };
            case "username_not_found":
                return { __html: `${error.DisplayMessage}. Please try again or for assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.` };
            case "memberid_not_found":
            case "member_not_found":
                return { __html: `The member ID was not found. Please try again or for assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.` };
            case "account_linking_failed":
            case "unhandled_exception":
                return { __html: `We were unable to link your account. For assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.` };
            case "login_already_exists":
                return { __html: `You may have duplicate accounts. Call the MyBSWHealth technical help desk ${technicalHelpDeskHours} at ${phoneNumber2} to correct this.` };
            default:
                return {
                    __html: `We were unable to link your account. For assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.`
                };
        }

    }
}

function getUnLinkAAError(error) {
    if (error && error.Code) {
        switch (error.Code) {
            case "username_not_found":
            case "account_unlinking_failed":
            case "unhandled_exception":
                return {
                    __html: `We were unable to unlink your account. For assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.`
                };
            default:
                return {
                    __html: `We were unable to unlink your account. For assistance, call the DFW ConnectedCare Center at ${phoneNumber} and press 1.`
                };
        }
    }
    return {
        __html: `We were unable to unlink your account.`
    };
}

function* linkFirstCareAccountAction(data) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(healthPlan.linkFirstCareAccount, domainData.t, domainData.un, data.dob, data.memberId);
                if (response && response.MembershipProfile) {
                    try {
                        yield put({ type: types.LINK_FIRST_CARE_ACCOUNT_SUCCESS });
                        logAPI("MBHWeb.Saga.FirstCare.Link.Success", new Date(), data);
                        yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: response.MembershipProfile });
                        yield put({ type: types.REFRESH_TOKEN });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.LINK_FIRST_CARE_ACCOUNT_CLEAR });
                            }, 10000);
                        }
                    }
                    catch (error) {
                        yield call(linkFirstCareAccountFailure, error, data);
                    }
                }
                else {
                    yield call(linkFirstCareAccountFailure, response, data);
                }
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.FirstCare.Link.Failure.Login", start, null, response);
            }
            else {
                yield call(linkFirstCareAccountFailure, response, data);
            }
        }
    }
    else {
        console.log("firstCare link failed");
    }
}

function* linkFirstCareAccountFailure(error, data = {}) {
    yield put({
        type: types.LINK_FIRST_CARE_ACCOUNT_FAILURE,
        error: error && typeof error === 'string' ? error : error && error.Errors && error.Errors[0] && error.Errors[0].DisplayMessage ? error.Errors[0].DisplayMessage : "We're unable to link your account."
    });
    logAPI("MBHWeb.Saga.FirstCare.Link.Failure", new Date(), null, { payload: data, error: error });
}

function* unlinkFirstCareAccountAction(data) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(healthPlan.unlinkFirstCareAccount, domainData.t, domainData.un, data.memberId);
                if (response && response.MembershipProfile) {
                    try {
                        yield put({ type: types.UNLINK_FIRST_CARE_ACCOUNT_SUCCESS });
                        logAPI("MBHWeb.Saga.FirstCare.Unlink.Success", new Date(), data);
                        yield put({ type: types.MEMBERSHIP_GET_SUCCESS, data: response.MembershipProfile });
                        yield put({ type: types.REFRESH_TOKEN });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.UNLINK_FIRST_CARE_ACCOUNT_CLEAR });
                            }, 10000);
                        }
                    }
                    catch (error) {
                        yield call(unlinkFirstCareAccountFailure, error);
                    }
                }
                else {
                    yield call(unlinkFirstCareAccountFailure, response);
                }
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.FirstCare.Unlink.Failure.Login", start, null, response);
            }
            else {
                yield call(unlinkFirstCareAccountFailure, response);
            }
        }
    }
    else {
        console.log("firstCare unlink failed");
    }
}

function* unlinkFirstCareAccountFailure(error) {
    yield put({
        type: types.UNLINK_FIRST_CARE_ACCOUNT_FAILURE,
        error: error && typeof error === 'string' ? error : error && error.Errors && error.Errors[0] && error.Errors[0].DisplayMessage ? error.Errors[0].DisplayMessage : "We're unable to unlink your account."
    });
    logAPI("MBHWeb.Saga.FirstCare.Unlink.Failure", new Date(), null, error);
}

function* linkDartAccountAction(action) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();
    const data = action.data;
    if (stateData) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(healthPlan.linkDartAccount, domainData.t, domainData.un, data.dob);
                if (response && response.MembershipProfile) {
                    try {
                        yield all([
                            put({ type: types.LINK_DART_ACCOUNT_SUCCESS, data: response.MembershipProfile }),
                            put({ type: types.MEMBERSHIP_GET_SUCCESS, data: response.MembershipProfile })
                        ]);

                        logAPI("MBHWeb.Saga.Dart.Link.Success", new Date(), data);
                        yield put({ type: types.REFRESH_TOKEN });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.LINK_DART_ACCOUNT_CLEAR });
                            }, 10000);
                        }
                        //optional Callback if needed
                        if (action && action.callback) {
                            action.callback("success", response.MembershipProfile);
                        }
                    }
                    catch (error) {
                        yield call(linkDartAccountFailure, error, data);
                    }
                }
                else {
                    yield call(linkDartAccountFailure, response, data);
                }
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.Dart.Link.Failure.Login", start, null, response);
            }
            else {
                yield call(linkDartAccountFailure, response, data);
            }
        }
    }
    else {
        console.log("dart link failed");
    }
}

function* linkDartAccountFailure(error, data = {}) {
    yield put({
        type: types.LINK_DART_ACCOUNT_FAILURE,
        error: error && typeof error === 'string' ? error : error && error.Errors && error.Errors[0] && error.Errors[0].DisplayMessage ? error.Errors[0].DisplayMessage : "We're unable to link your account."
    });
    logAPI("MBHWeb.Saga.Dart.Link.Failure", new Date(), null, { payload: data, error: error });
}

function* linkWACOAccountAction(action) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();
    const data = action.data;
    if (stateData) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(healthPlan.linkWACOAccount, domainData.t, domainData.un, data.dob);
                if (response && response.MembershipProfile) {
                    try {
                        yield all([
                            put({ type: types.LINK_WACO_ACCOUNT_SUCCESS, data: response.MembershipProfile }),
                            put({ type: types.MEMBERSHIP_GET_SUCCESS, data: response.MembershipProfile })
                        ]);
                        logAPI("MBHWeb.Saga.WACO.Link.Success", new Date(), data);
                        yield put({ type: types.REFRESH_TOKEN });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.LINK_WACO_ACCOUNT_CLEAR });
                            }, 10000);
                        }
                        //optional Callback if needed
                        if (action && action.callback) {
                            action.callback("success", response.MembershipProfile);
                        }
                    }
                    catch (error) {
                        yield call(linkWACOAccountFailure, error, data);
                    }
                }
                else {
                    yield call(linkWACOAccountFailure, response, data);
                }
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.WACO.Link.Failure.Login", start, null, response);
            }
            else {
                yield call(linkWACOAccountFailure, response, data);
            }
        }
    }
    else {
        console.log("WACO link failed");
    }
}

function* linkWACOAccountFailure(error, data = {}) {
    yield put({
        type: types.LINK_WACO_ACCOUNT_FAILURE,
        error: error && typeof error === 'string' ? error : error && error.Errors && error.Errors[0] && error.Errors[0].DisplayMessage ? error.Errors[0].DisplayMessage : "We're unable to link your account."
    });
    logAPI("MBHWeb.Saga.WACO.Link.Failure", new Date(), null, { payload: data, error: error });
}

function* unlinkDartAccountAction(data) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(healthPlan.unlinkDartAccount, domainData.t, domainData.un);
                if (response && response.MembershipProfile) {
                    try {
                        yield all([
                            put({ type: types.UNLINK_DART_ACCOUNT_SUCCESS, data: response.MembershipProfile }),
                            put({ type: types.MEMBERSHIP_GET_SUCCESS, data: response.MembershipProfile })
                        ]);
                        logAPI("MBHWeb.Saga.Dart.Unlink.Success", new Date(), data);
                        yield put({ type: types.REFRESH_TOKEN });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.UNLINK_DART_ACCOUNT_CLEAR });
                            }, 10000);
                        }
                    }
                    catch (error) {
                        yield call(unlinkDartAccountFailure, error);
                    }
                }
                else {
                    yield call(unlinkDartAccountFailure, response);
                }
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.Dart.Unlink.Failure.Login", start, null, response);
            }
            else {
                yield call(unlinkDartAccountFailure, response);
            }
        }
    }
    else {
        console.log("Dart unlink failed");
    }
}

function* unlinkDartAccountFailure(error) {
    yield put({
        type: types.UNLINK_DART_ACCOUNT_FAILURE,
        error: error && typeof error === 'string' ? error : error && error.Errors && error.Errors[0] && error.Errors[0].DisplayMessage ? error.Errors[0].DisplayMessage : "We're unable to unlink your account."
    });
    logAPI("MBHWeb.Saga.Dart.Unlink.Failure", new Date(), null, error);
}

function* unlinkWacoAccountAction(data) {
    const domainData = yield select((state) => state.domain);
    const stateData = yield select((state) => state.common);
    const start = new Date();

    if (stateData) {
        try {
            if (domainData && domainData.t) {
                const response = yield call(healthPlan.unlinkWacoAccount, domainData.t, domainData.un);
                if (response && response.MembershipProfile) {
                    try {
                        yield all([
                            put({ type: types.UNLINK_WACO_ACCOUNT_SUCCESS, data: response.MembershipProfile }),
                            put({ type: types.MEMBERSHIP_GET_SUCCESS, data: response.MembershipProfile })
                        ]);
                        logAPI("MBHWeb.Saga.Waco.Unlink.Success", new Date(), data);
                        yield put({ type: types.REFRESH_TOKEN });
                        if (!data.isStandalone) {
                            window.setTimeout(() => {
                                window.store.dispatch({ type: types.UNLINK_WACO_ACCOUNT_CLEAR });
                            }, 10000);
                        }
                    }
                    catch (error) {
                        yield call(unlinkWacoAccountFailure, error);
                    }
                }
                else {
                    yield call(unlinkWacoAccountFailure, response);
                }
            }
        }
        catch (response) {
            if (response && response.status && response.status === 401) {
                yield put({ type: types.VERIFY_LOGIN, errorCode: response.status });
                logAPI("MBHWeb.Saga.Waco.Unlink.Failure.Login", start, null, response);
            }
            else {
                yield call(unlinkWacoAccountFailure, response);
            }
        }
    }
    else {
        console.log("Waco unlink failed");
    }
}

function* unlinkWacoAccountFailure(error) {
    yield put({
        type: types.UNLINK_WACO_ACCOUNT_FAILURE,
        error: error && typeof error === 'string' ? error : error && error.Errors && error.Errors[0] && error.Errors[0].DisplayMessage ? error.Errors[0].DisplayMessage : "We're unable to unlink your account."
    });
    logAPI("MBHWeb.Saga.Waco.Unlink.Failure", new Date(), null, error);
}